<template>
    <div v-if="showPassport">
        <v-btn
            variant="text"
            color="primary"
            :append-icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
            @click="expanded = !expanded"
        >
            {{ $t('passport_data') }}
        </v-btn>
        <v-expand-transition>
            <v-form v-show="expanded" ref="form" :disabled="disabled" class="mt-2">
                <v-row>
                    <!--v-col cols="12" md="3">
                        <v-select
                            v-model="type"
                            :items="['PASSPORT', 'PASSPORT_EXTERNAL', 'BIRTH_CERTIFICATE', 'OTHER']"
                            :label="fieldLabel('document_type', 'PASSPORT_TYPE')"
                            clearable
                            :rules="[requiredRule('document_type', 'PASSPORT_TYPE')]"
                        >
                            <template v-slot:item="{item}">
                                {{ $t(`documentTypes.${item}`) }}
                            </template>
                            <template v-slot:selection="{item}">
                                {{ $t(`documentTypes.${item}`) }}
                            </template>
                        </v-select>
                    </v-col-->
                    <v-col v-if="!isFieldDisabled('PASSPORT_NUMBER')" cols="12" md="3">
                        <v-text-field
                            v-model="number"
                            :label="fieldLabel('document_number', 'PASSPORT_NUMBER')"
                            :rules="[requiredRule('document_number', 'PASSPORT_NUMBER')]"
                            variant="outlined"
                            density="comfortable"
                            autocomplete="one-time-code"
                        />
                    </v-col>
                    <v-col v-if="!isFieldDisabled('PASSPORT_ISSUE_DATE')" cols="12" md="3">
                        <date-picker
                            v-model="issueDate"
                            :label="fieldLabel('issue_date', 'PASSPORT_ISSUE_DATE')"
                            :rules="[requiredRule('issue_date', 'PASSPORT_ISSUE_DATE')]"
                            :max="today"
                            year-active-picker
                            :disabled="disabled"
                        />
                    </v-col>
                    <v-col v-if="!isFieldDisabled('PASSPORT_EXPIRE_DATE')" cols="12" md="3">
                        <date-picker
                            v-model="expiryDate"
                            :label="fieldLabel('expire_date', 'PASSPORT_EXPIRE_DATE')"
                            :rules="[requiredRule('expire_date', 'PASSPORT_EXPIRE_DATE')]"
                            :min="today"
                            year-active-picker
                            :disabled="disabled"
                        />
                    </v-col>
                    <v-col v-if="!isFieldDisabled('PASSPORT_ISSUE_COUNTRY') && isShowCountryOfIssueId" cols="12" md="3">
                        <v-select
                            v-model="countryOfIssueId"
                            clearable
                            item-title="name"
                            :items="citizenshipItems"
                            :label="$t('issue_country')"
                            variant="outlined"
                            density="comfortable"
                        />
                    </v-col>
                </v-row>
            </v-form>
        </v-expand-transition>
    </div>
</template>

<script lang="ts">
    import {Component, Emit, mixins, Prop} from 'vue-facing-decorator'
    import {BookingFieldsMixin} from '@/components/booking/mixins/BookingFieldsMixin.vue'
    import DatePicker from '@/components/snippets/forms/DatePicker.vue'

    @Component({
        components: {DatePicker},
    })
    export class TouristPassportForm extends mixins(BookingFieldsMixin) {
        @Prop({required: true}) index
        @Prop() disabled
        @Prop() corporatePolicyViolation
        @Prop({required: false, type: Boolean}) expandedAll

        expanded = false

        mounted() {
            this.expanded = this.expandedAll || this.index === 0
        }

        getProp(prop) {
            return persistentStore.tourists[this.index].passport[prop]
        }

        @Emit()
        setProp(prop, val) {
            const index = this.index
            persistentStore.SET_TOURIST_PASSPORT_PROP({prop, val, index})
        }

        get today() {
            return new Date().toISOString()
        }

        get type() {
            return this.getProp('type')
        }

        set type(val) {
            this.setProp('type', val)
        }

        get number() {
            return this.getProp('number')
        }

        set number(val) {
            this.setProp('number', val)
        }

        get issueDate() {
            return this.getProp('issueDate')
        }

        set issueDate(val) {
            this.setProp('issueDate', val)
        }

        get expiryDate() {
            return this.getProp('expiryDate')
        }

        set expiryDate(val) {
            this.setProp('expiryDate', val)
        }

        get countryOfIssueId() {
            return this.getProp('countryOfIssueId')
        }

        set countryOfIssueId(val) {
            this.setProp('countryOfIssueId', val)
        }

        get isShowCountryOfIssueId() {
            return false
        }

        get personId() {
            return persistentStore.tourists[this.index].personId
        }

        get citizenshipItems() {
            return runtimeStore.restrictedCountries.map(({id, name}) => {
                return {
                    name,
                    value: id,
                }
            })
        }

        get showPassport() {
            const bookingFields = runtimeStore.touristBookingFields.bookingFields
            const passportFieldKeys = [
                // 'PASSPORT_ISSUE_COUNTRY',
                'PASSPORT_EXPIRE_DATE',
                'PASSPORT_ISSUE_DATE',
                'PASSPORT_NUMBER',
            ]
            // return (
            //     bookingFields &&
            //     passportFieldKeys.findIndex(fieldKey => !this.isFieldDisabled(fieldKey)) !== -1 &&
            //     (!this.corporatePolicyViolation || (this.corporatePolicyViolation && !!this.personId))
            // )
            // GPFE-6151 - temporary solution
            return bookingFields && passportFieldKeys.findIndex(fieldKey => !this.isFieldDisabled(fieldKey)) !== -1
        }

        get tourist() {
            return persistentStore.tourists[this.index]
        }
    }

    export default TouristPassportForm
</script>
